// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmark-feed-page {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

:root[data-maincontent="wide"] .bookmark-feed-page {
  max-width: 100%;
}

.bookmark-feed-header {
  width: 100%;
  box-sizing: border-box;
  margin: 16px 0 24px;
}

.bookmark-feed-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.bookmark-feed-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bookmark-feed-back {
  display: inline-block;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
}

.bookmark-feed-back:hover {
  color: var(--accent-primary);
}

.bookmark-rename-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bookmark-rename-btn:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.bookmark-delete-btn {
  background: none;
  border: 1px solid var(--error-color, #e05252);
  color: var(--error-color, #e05252);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bookmark-delete-btn:hover {
  background: var(--error-color, #e05252);
  color: #fff;
}

.bookmark-feed-rename-form {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
}

.bookmark-feed-rename-input {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border: 1px solid var(--accent-primary);
  border-radius: 6px;
  padding: 6px 10px;
  outline: none;
  flex: 1 1;
  max-width: 320px;
}

.bookmark-rename-submit-btn,
.bookmark-rename-cancel-btn {
  font-size: 12px;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
}

.bookmark-rename-submit-btn {
  background: var(--accent-primary);
  color: #fff;
  border: none;
}

.bookmark-rename-submit-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.bookmark-rename-cancel-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.bookmark-feed-title {
  margin: 0 0 16px;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.bookmark-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 1rem;
}

.bookmark-search-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.bookmark-feed-content {
  width: 100%;
  box-sizing: border-box;
}

.bookmark-error {
  color: var(--error-color);
  text-align: center;
  padding: 24px 0;
}

.bookmark-empty {
  color: var(--text-secondary);
  text-align: center;
  padding: 40px 0;
}

.bookmark-list {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.bookmark-list .post-card,
.bookmark-list .comment-card {
  width: 100%;
  box-sizing: border-box;
}

/* Post Actions styling in Bookmarks */
.bookmark-post-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
}

.copy-link-wrapper {
  position: relative;
  display: inline-flex;
}

.copy-link-notice {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BookmarkFeed.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf","sourcesContent":[".bookmark-feed-page {\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 0 16px 32px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n:root[data-maincontent=\"wide\"] .bookmark-feed-page {\n  max-width: 100%;\n}\n\n.bookmark-feed-header {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 16px 0 24px;\n}\n\n.bookmark-feed-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.bookmark-feed-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bookmark-feed-back {\n  display: inline-block;\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.2s ease;\n}\n\n.bookmark-feed-back:hover {\n  color: var(--accent-primary);\n}\n\n.bookmark-rename-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bookmark-rename-btn:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.bookmark-delete-btn {\n  background: none;\n  border: 1px solid var(--error-color, #e05252);\n  color: var(--error-color, #e05252);\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bookmark-delete-btn:hover {\n  background: var(--error-color, #e05252);\n  color: #fff;\n}\n\n.bookmark-feed-rename-form {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 16px;\n}\n\n.bookmark-feed-rename-input {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n  border: 1px solid var(--accent-primary);\n  border-radius: 6px;\n  padding: 6px 10px;\n  outline: none;\n  flex: 1;\n  max-width: 320px;\n}\n\n.bookmark-rename-submit-btn,\n.bookmark-rename-cancel-btn {\n  font-size: 12px;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.bookmark-rename-submit-btn {\n  background: var(--accent-primary);\n  color: #fff;\n  border: none;\n}\n\n.bookmark-rename-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.bookmark-rename-cancel-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n}\n\n.bookmark-feed-title {\n  margin: 0 0 16px;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.bookmark-search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: 1rem;\n}\n\n.bookmark-search-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.bookmark-feed-content {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.bookmark-error {\n  color: var(--error-color);\n  text-align: center;\n  padding: 24px 0;\n}\n\n.bookmark-empty {\n  color: var(--text-secondary);\n  text-align: center;\n  padding: 40px 0;\n}\n\n.bookmark-list {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.bookmark-list .post-card,\n.bookmark-list .comment-card {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Post Actions styling in Bookmarks */\n.bookmark-post-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color);\n}\n\n.copy-link-wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.copy-link-notice {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.85);\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
